import { render, staticRenderFns } from "./CollabRolesDetail.vue?vue&type=template&id=d26fc33c"
import script from "./CollabRolesDetail.vue?vue&type=script&lang=js"
export * from "./CollabRolesDetail.vue?vue&type=script&lang=js"
import style0 from "./CollabRolesDetail.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports